export const pptxImportTranslation = {
  confirm: {
    cancel: 'Anuluj',
  },
  description:
    'Wgraj prezentację ofertową (PPTX). AI odczyta z niej dania i zestawy grup, porówna dania z katalogiem ' +
    'i zaproponuje te, które już w nim są. Ty poprawiasz szkic — nazwy, reguły wyboru, ceny, tagi, typy ' +
    'wydarzeń — a import idzie tym samym mechanizmem co import z arkusza, więc wygenerowany arkusz zobaczysz ' +
    'też w historii importów (zakładka XLSX).',
  dishes: {
    aiMatch: 'AI: to samo danie',
    catalogueDish: 'W katalogu: {{name}}',
    department: 'Dział',
    dismiss: 'To inne danie',
    edit: 'Edytuj',
    empty: 'Brak dań w tym widoku.',
    filterAll: 'Wszystkie',
    filterCatalogue: 'W katalogu',
    filterMissing: 'Z brakami',
    filterNew: 'Nowe',
    filtersLabel: 'Pokaż',
    filterSuggestions: 'Z podpowiedzią',
    link: 'Połącz',
    measurement: 'Porcja',
    name: 'Danie',
    otherCandidates: 'Inne propozycje ({{count}})',
    placeholder: 'dane zastępcze',
    prices: 'FC / min / sug.',
    remove: 'Usuń danie',
    removeConfirm: 'Usunąć „{{name}}” ze szkicu i ze wszystkich zestawów?',
    reviewAll: 'Przeglądaj danie po daniu',
    reviewHint:
      'Jedno danie naraz, obok slajd, z którego pochodzi. Strzałki ← → przełączają dania, ' +
      'a zmiany zapisują się przy przejściu do następnego.',
    reviewToFill: 'Uzupełniaj danie po daniu ({{count}} do uzupełnienia)',
    similarInCatalogue: 'Podobne w katalogu ({{count}})',
    slides: 'Slajdy',
    status: 'Status',
    statusCatalogue: 'W katalogu',
    statusNew: 'Nowe',
    suggestion: 'Podobne w katalogu: {{name}}',
    tableScope: 'Tabela: {{filter}}',
    type: 'Rodzaj',
    units: {
      GRAM: 'g',
      MILLILITER: 'ml',
      UNIT: 'szt.',
    },
    usedIn: 'Zestawy',
  },
  draft: {
    back: 'Wszystkie szkice',
    downloadWorkbook: 'Pobierz arkusz XLSX',
    extractAgain: 'Odczytaj ponownie',
    extractAgainConfirm:
      'Odczytać prezentację od nowa? Wszystkie poprawki w tym szkicu zostaną zastąpione nowym odczytem.',
    extracting:
      'AI czyta prezentację — najpierw dania ze slajdów, potem zestawy. Zwykle trwa to do 2 minut.',
    failed: 'Nie udało się odczytać prezentacji',
    fields: {
      department: 'dział',
      foodCost: 'FC',
      measurement: 'gramatura',
      minimumSalePrice: 'cena min.',
      suggestedSalePrice: 'cena sugerowana',
      type: 'rodzaj',
    },
    filled: 'Uzupełniono {{count}} dań danymi zastępczymi — mają tag DO_WYCENY.',
    fillPlaceholders: 'Uzupełnij braki danymi zastępczymi',
    fillPlaceholdersHint:
      'Brakujący dział, rodzaj, gramatura, FC i ceny zostaną zmyślone wg reguł (FC wg rodzaju dania, ' +
      'cena min. = FC / 0,4, sugerowana = FC / 0,3). Każde takie danie dostanie tag DO_WYCENY.',
    import: 'Importuj do katalogu',
    importConfirm:
      'Do katalogu trafią zestawy ({{sets}}) i nowe dania ({{dishes}}). Dania połączone z katalogiem nie ' +
      'powstaną drugi raz. Zestaw, którego nazwa już istnieje w katalogu, zostanie pominięty.',
    importConfirmErrors:
      'Uwaga: nowe dania z brakami, użyte w zestawach: {{count}}. Importer ich nie utworzy, więc zestawy zostaną bez nich.',
    importConfirmTitle: 'Import do katalogu',
    imported: 'Zaimportowano {{date}}',
    importedTitle: 'Wynik importu',
    importing: 'Importowanie…',
    issues: {
      dishCatalogueMatch: '„{{name}}” — AI: to samo danie co „{{suggestion}}” w katalogu',
      dishInvalidSeasonality:
        '„{{name}}” — sezonowość „{{value}}” ma zły format (potrzebne DD.MM-DD.MM albo pusto = cały rok)',
      dishMissingFields: '„{{name}}” — brakuje: {{fields}}',
      dishSuggestion: '„{{name}}” — w katalogu jest podobne „{{suggestion}}”',
      dishUnused: '„{{name}}” — nie należy do żadnego zestawu',
      duplicateSetName: 'Dwa zestawy nazywają się „{{name}}”',
      none: 'Szkic nie ma problemów — można importować.',
      setWithoutEventType:
        'Zestaw „{{name}}” nie ma typu wydarzenia — będzie pasował do każdego wydarzenia',
      setWithoutGroups: 'Zestaw „{{name}}” nie ma grup',
      setWithoutPrice: 'Zestaw „{{name}}” nie ma ceny za osobę',
      showAll: 'Pokaż wszystkie ({{count}})',
      showLess: 'Zwiń',
      subgroupChoiceTooFew: '{{set}} / {{subgroup}}: wybór {{max}} z puli {{count}} dań',
      subgroupEmpty: '{{set}} / {{subgroup}}: podgrupa bez dań',
      subgroupMissingMax: '{{set}} / {{subgroup}}: brak liczby porcji lub gramów na osobę',
      summary: 'błędy: {{errors}} · ostrzeżenia: {{warnings}} · uwagi: {{infos}}',
      title: 'Do sprawdzenia',
    },
    linkAiSuggestions: 'Połącz z katalogiem potwierdzone przez AI ({{count}})',
    linkAiSuggestionsHint:
      'Dania, które AI uznało za te same co w katalogu, zostaną z nimi połączone — nie powstaną drugi raz, ' +
      'a zestawy użyją pozycji z katalogu razem z ich cenami.',
    linked: 'Połączono z katalogiem: {{count}}',
    notesTitle: 'Uwagi z odczytu',
    reviewDishes: 'Uzupełniaj dania po kolei ({{count}})',
    reviewSets: 'Zestawy z uwagami po kolei ({{count}})',
    save: 'Zapisz zmiany',
    saved: 'Wszystko zapisane',
    showPresentation: 'Pokaż prezentację',
    tabs: {
      dishes: 'Dania ({{count}})',
      sets: 'Zestawy ({{count}})',
      slides: 'Slajdy ({{count}})',
    },
    unsaved: 'Niezapisane zmiany',
  },
  list: {
    createdAt: 'Wgrano',
    createdBy: 'Osoba',
    delete: 'Usuń szkic',
    deleteConfirm: 'Usunąć szkic „{{name}}”? Zestawy już zaimportowane do katalogu zostaną.',
    empty: 'Nie wgrano jeszcze żadnej prezentacji.',
    fileName: 'Prezentacja',
    status: 'Status',
    title: 'Szkice importu',
  },
  pickFile: 'Wgraj prezentację PPTX',
  review: {
    close: 'Zamknij',
    dishCounter: 'Danie {{number}} z {{count}}',
    dishesTitle: 'Uzupełnianie dań',
    emptyDishes: 'Brak dań w tym zakresie',
    emptySets: 'Brak zestawów w tym zakresie',
    fillSetDishes: 'Uzupełnij dania tego zestawu ({{count}})',
    finish: 'Zakończ',
    legend: 'gotowe: {{done}} · do sprawdzenia: {{check}} · braki: {{missing}}',
    nextHint: 'Następne (→)',
    nextSet: 'Następny zestaw',
    previousHint: 'Poprzednie (←)',
    previousSet: 'Poprzedni zestaw',
    removeSet: 'Usuń zestaw',
    removeSetConfirm: 'Usunąć zestaw „{{name}}” ze szkicu?',
    reviewSetDishes: 'Przejrzyj dania tego zestawu ({{count}})',
    save: 'Zapisz',
    saved: 'Wszystko zapisane',
    saving: 'Zapisywanie…',
    scope: 'Zakres',
    scopes: {
      all: 'Wszystkie ({{count}})',
      allSets: 'Wszystkie ({{count}})',
      attention: 'Do uzupełnienia ({{count}})',
      new: 'Nowe ({{count}})',
      setsWithIssues: 'Z uwagami ({{count}})',
    },
    setCounter: 'Zestaw {{number}} z {{count}}',
    setDishesHint: 'Otworzy kreator tylko dla dań tego zestawu.',
    setScope: 'Zestaw „{{name}}”',
    setsTitle: 'Zestawy po kolei',
    unsaved: 'Niezapisane zmiany',
  },
  sets: {
    addDish: 'Dodaj danie ze szkicu albo z katalogu…',
    addGroup: 'Dodaj grupę',
    addSet: 'Dodaj zestaw',
    addSubgroup: 'Dodaj podgrupę',
    allSetsEventTypes: 'Typ wydarzenia dla wszystkich zestawów',
    allSetsEventTypesHint:
      'Kliknięcie ustawia albo zdejmuje typ we wszystkich zestawach naraz; pojedynczy zestaw poprawisz niżej. ' +
      'Zestaw bez typu pasuje do każdego wydarzenia.',
    categories: {
      DESSERT: 'Deser',
      DISH: 'Potrawa',
      DRINK: 'Napój',
    },
    category: 'Kategoria',
    comment: 'Komentarz zestawu',
    copySuffix: '(kopia)',
    createDish: 'Nowe danie: „{{name}}”',
    duplicate: 'Duplikuj zestaw',
    emptyPool: 'Brak dań w podgrupie.',
    eventTypes: 'Typy wydarzenia',
    excluded: 'Pominięty przy imporcie',
    group: 'Grupa',
    groupCatalogue: 'Z katalogu',
    groupDraft: 'W szkicu',
    groupNew: 'Nowe danie',
    inCatalogue: 'w katalogu',
    include: 'Importuj ten zestaw',
    max: 'Maks.',
    min: 'Min.',
    minGuests: 'Min. liczba osób',
    mode: 'Reguła wyboru',
    modes: {
      CHOICE: 'Wybór N dań',
      GRAMS: 'Gramy na osobę',
      NONE: 'Brak reguły',
      PORTIONS: 'Porcje na osobę',
      UNLIMITED: 'Bez limitu',
    },
    name: 'Nazwa zestawu',
    newGroupName: 'Nowa grupa',
    newSetName: 'Nowy zestaw',
    newSubgroupName: 'Nowa podgrupa',
    noSets: 'Szkic nie ma zestawów — dodaj pierwszy albo odczytaj prezentację ponownie.',
    openInReview: 'Po kolei',
    price: 'Cena za osobę (zł netto)',
    remove: 'Usuń zestaw',
    removeConfirm: 'Usunąć zestaw „{{name}}” ze szkicu?',
    removeGroup: 'Usuń grupę',
    removeSubgroup: 'Usuń podgrupę',
    reviewOneByOne: 'Przeglądaj zestaw po zestawie',
    reviewOneByOneHint:
      'Jeden zestaw naraz, obok slajd z prezentacji. Strzałki ← → przełączają zestawy.',
    subgroup: 'Podgrupa',
    subgroupComment: 'Komentarz podgrupy (reguła z prezentacji)',
    suggestionChip:
      'W katalogu jest podobne danie „{{name}}” — kliknij, żeby połączyć albo odrzucić',
    validFrom: 'Ważne od',
    validTo: 'Ważne do',
  },
  slides: {
    closePanel: 'Schowaj prezentację',
    dishes: 'Dania z tego slajdu: {{count}}',
    hideText: 'Ukryj tekst slajdu',
    images: 'obrazy: {{count}}',
    next: 'Następny slajd',
    noImage:
      'Nie udało się narysować tego slajdu — jego tekst jest pod przyciskiem „Pokaż tekst slajdu”.',
    noText: 'Brak tekstu na slajdzie.',
    notFoundOnSlide: 'tej nazwy nie znalazłem na slajdzie',
    presentation: 'Prezentacja',
    previous: 'Poprzedni slajd',
    renderFailed: 'Nie udało się przygotować podglądu slajdów ({{message}}). Poniżej tekst slajdu.',
    rendering: 'Przygotowuję podgląd slajdów — do tego czasu widać ich tekst.',
    renderUnavailable: 'Podgląd slajdów jest teraz niedostępny. Poniżej tekst slajdu.',
    sets: 'Zestawy z tego slajdu: {{count}}',
    showText: 'Pokaż tekst slajdu',
    slide: 'Slajd {{number}}',
    slideOf: 'Slajd {{number}} z {{count}}',
    slideScope: 'Slajd {{number}}',
    slideShort: 'Slajd {{number}}',
    sourceSlides: 'Źródło w prezentacji: {{slides}}',
    zoomIn: 'Powiększ',
    zoomOut: 'Dopasuj do szerokości',
  },
  status: {
    EXTRACTING: 'Odczytywanie…',
    FAILED: 'Błąd odczytu',
    IMPORTED: 'Zaimportowany',
    READY: 'Do sprawdzenia',
  },
  uploadHint:
    'Po wgraniu AI czyta prezentację w tle (zwykle do 2 minut) — możesz zostać albo wrócić później, szkic ' +
    'się zapisze. Menu wklejone jako obrazki nie zostanie odczytane.',
  uploading: 'Wgrywanie…',
  wizard: {
    add: 'Dodaj',
    addedToDictionary: 'Dodano „{{name}}” do słownika: {{dictionary}}',
    adding: 'Dodawanie…',
    addToDictionary: 'Dodaj „{{value}}” do słownika',
    aiSame: 'AI: to samo danie — {{reason}}',
    cancelNewItem: 'Anuluj',
    candidatesHint: 'Czy to danie jest już w katalogu? Połączone nie powstanie drugi raz.',
    catalogueTitle: 'Katalog',
    complete: 'Danie gotowe do importu.',
    confirm: 'Potwierdź',
    department: 'Dział',
    description: 'Opis / dodatki w cenie',
    descriptionHint: 'Co wchodzi w danie, dodatki w cenie',
    dictionaries: {
      department: 'Działy',
      diet: 'Preferencje żywieniowe',
      tag: 'Tagi',
      type: 'Rodzaje dań',
    },
    dietOptions: {
      fish: 'Ryba',
      glutenFree: 'Bez glutenu',
      lactoseFree: 'Bez laktozy',
      meat: 'Mięso',
      vegan: 'Wegańskie',
      vegetarian: 'Wegetariańskie',
    },
    diets: 'Diety',
    finish: 'Zakończ',
    foodCost: 'FC pozycji',
    linked: 'Połączone z katalogiem: {{name}}',
    linkedHint:
      'Zestawy użyją tej pozycji z katalogu razem z jej ceną i gramaturą — nic więcej nie trzeba uzupełniać.',
    measurement: 'Porcja',
    measurementValue: 'Gramatura ({{unit}})',
    minimumMargin: 'marża przy cenie min.: {{value}}%',
    minimumSalePrice: 'Cena minimalna',
    missing: 'brak',
    name: 'Nazwa dania',
    newDish: 'Nowe danie',
    newItem: 'Nowa pozycja w słowniku',
    newItemHint:
      'Pozycja trafi od razu do słownika, więc będzie do wyboru także przy innych daniach.',
    newItemPlaceholder: 'Nowa pozycja: {{label}}',
    next: 'Następne danie',
    noCatalogueResults: 'Brak dań o tej nazwie',
    noSuggestions: 'Brak podpowiedzi — wyszukaj albo pokaż wszystkie.',
    nothingFound: 'Nic nie pasuje.',
    notInCatalogue: 'Nie, to nowe danie',
    placeholder: 'dane zastępcze',
    placeholderTagHint: 'Dane zastępcze są już potwierdzone — tag {{tag}} nie jest potrzebny.',
    previous: 'Poprzednie danie',
    prices: 'Ceny (zł netto)',
    pricesFromFoodCost: 'Wylicz ceny z FC',
    pricesFromFoodCostHint: 'wyliczenie: min. = FC / 0,4, sugerowana = FC / 0,3',
    quickMeasurement: 'Szybki wybór',
    remaining: 'Zostało: {{sections}}',
    removePlaceholderTag: 'Zdejmij {{tag}}',
    sameDish: 'To samo danie',
    score: 'zgodność nazwy {{score}}%',
    searchCatalogue: 'Szukaj w katalogu…',
    searchIn: 'Szukaj: {{label}}…',
    season: {
      exact: 'Dokładne daty (DD.MM-DD.MM)',
      invalid: 'Zły format — wpisz np. 01.05-30.06 albo zostaw puste (cały rok).',
      months: {
        1: 'styczeń',
        10: 'październik',
        11: 'listopad',
        12: 'grudzień',
        2: 'luty',
        3: 'marzec',
        4: 'kwiecień',
        5: 'maj',
        6: 'czerwiec',
        7: 'lipiec',
        8: 'sierpień',
        9: 'wrzesień',
      },
      monthsHint: 'Kliknij miesiąc początku, potem miesiąc końca sezonu (np. lis → lut).',
      monthsHintEnd: 'Początek: {{month}}. Teraz kliknij miesiąc końca sezonu.',
      monthsShort: {
        1: 'sty',
        10: 'paź',
        11: 'lis',
        12: 'gru',
        2: 'lut',
        3: 'mar',
        4: 'kwi',
        5: 'maj',
        6: 'cze',
        7: 'lip',
        8: 'sie',
        9: 'wrz',
      },
      presets: {
        autumn: 'Jesień (wrz–lis)',
        spring: 'Wiosna (mar–maj)',
        summer: 'Lato (cze–sie)',
        winter: 'Zima (gru–lut)',
        yearRound: 'Cały rok',
      },
      presetsLabel: 'Sezon',
      summary: 'Dostępne: {{from}} – {{to}} ({{range}})',
      summaryYearRound: 'Dostępne przez cały rok',
      title: 'Sezonowość',
    },
    section: 'Sekcja w prezentacji: {{section}}',
    sections: {
      catalogue: 'decyzja o katalogu',
      department: 'dział',
      measurement: 'porcja',
      prices: 'ceny',
      type: 'rodzaj',
    },
    showAll: 'Pokaż wszystkie ({{count}})',
    showSuggested: 'Tylko podpowiedzi',
    suggestedMargin: 'przy sugerowanej: {{value}}%',
    suggestedSalePrice: 'Cena sugerowana',
    tags: 'Tagi',
    type: 'Rodzaj dania',
    typeToSearch: 'Wpisz min. 3 litery',
    unit: 'Jednostka',
    unlink: 'Odłącz — to nowe danie',
    unused: 'Nie należy do żadnego zestawu',
  },
};

export type PptxImportTranslation = typeof pptxImportTranslation;
